import { Swiper } from './swiper-DDnfT8S0.js';
import { A as A11y } from './a11y-DMhWZZ38.js';
import './utils-CPPFXbqB.js';

class ProductComplementaryProducts extends HTMLElement {
  connectedCallback() {
    new Swiper(this, {
      modules: [A11y],
      slidesPerView: 1.6,
      spaceBetween: 12,
      breakpoints: {
        480: { slidesPerView: 1.8 },
        1024: { slidesPerView: 2.1 },
      },
    });
  }
}

customElements.define('product-complementary-products', ProductComplementaryProducts);
